import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { ApiService } from '../services/api.service';
import { SchemeService } from '../services/scheme.service';

@Component({
  selector: 'app-scheme-component',
  standalone: false,
  templateUrl: './scheme-component.component.html',
  styleUrl: './scheme-component.component.scss'
})
export class SchemeComponentComponent implements OnInit {
  isSkipStep: boolean = false;
  isCardView: boolean = true;
  skipReason: string = '';
  selectedStage: number | null = null;
  currentStage: number = 1;
  title: string = 'Proposals Master';
  proposalData: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 9;
  addProposalVisible: boolean = false;

  stages: any[] = []
  schemes = []
  isAddProposal: boolean;
  proposalForm: FormGroup;
  filteredSchemes: any[] = [];
  selectedScheme: any = null;
  isUpdateProposal: boolean = false;
  selectedProposal: any;
  isDeleteProposal: boolean = false;
  funds: any = [];
  filteredFunds: any[] = [];
  selectedFund: any = null;
  filteredRecentProposals: any[] = [];
  routeForm: FormGroup;
  RouteUserList: any[] = [];
  userListCopy: any;
  unitList = [];
  tabList: any;
  activeTabIndex = 0;
  addMode: 'new' | 'existing' = 'new';
  activeTabName: string = '';
  selectedPhaseId: any;
  currentPhaseName: string = '';
  previousPhaseStages: any[] = [];
  transactionPhaseStages: any[] = [];
  searchProposalQuery: string = '';
  selectedFundDisplay: string = '';
  activeIndex = 0;
  items: any
  roleList = []
  userList = []
  levelList = [{ id: 1, name: 'Level 1' }, { id: 2, name: 'Level 2' }, { id: 3, name: 'Level 3' }, { id: 4, name: 'Level 4' }, { id: 5, name: 'Level 5' }]
  routeList = []
  steps: any[] = [];
  activePhaseId: any
  stepId: number | null = null;
  roleID: number | null = null;
  userID: number | null = null;
  stagesList: any[] = []
  cols: any[] = [
    { field: 'name', header: 'Proposal Name', filterType: 'text' },
    { field: 'scheme.name', header: 'Scheme Name', filterType: 'text' },
    { field: 'fund.major_head', header: 'Fund Major Head', filterType: 'text' },
    { field: 'fund.minor_head', header: 'Fund Minor Head', filterType: 'text' },
    { field: 'proposal_status', header: 'Proposal Status', filterType: 'text' },

  ];
  userCols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' },
    { field: 'role.name', header: 'Role', filterType: 'text' },

  ];
  filteredStagesList: any[] = []
  currentUserRoleCode = sessionStorage.getItem('user_role_code')
  private subscriptions = new Subscription();

  constructor(
    private apiService: ApiService,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private schemeService: SchemeService
  ) {
    this.proposalForm = this.fb.group({
      proposalName: ['', Validators.required],
      description: [''],
      scheme: [null, Validators.required],
      // fund: ['', Validators.required],
      status: [1],

    });
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: [''],
      user: [''],
      unit: [''],
      level: [{ value: '', disabled: true }],
      approved: [false]
    })
  }

  ngOnInit(): void {
    this.getTabs();
    this.getSchemes()
    // this.getProposal();
    if (this.currentUserRoleId == '6') {
      this.items = [
        { label: 'Add Proposal', command: () => this.activeIndex = 0 },
        { label: 'Skip Stages', command: () => this.activeIndex = 1 },
        { label: 'Route Configuration', command: () => { this.apiCallForTransaction(); this.activeIndex = 2; } }
      ];
    } else {
      this.items = [
        { label: 'Add Proposal', command: () => this.activeIndex = 0 },
        { label: 'Route Configuration', command: () => { this.apiCallForTransaction(); this.activeIndex = 1; } }
      ];
    }
    this.proposalForm.get('scheme')?.valueChanges.subscribe(val => {
      this.selectedScheme = val;  // ⬅️ Store the selected scheme object
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  currentUserRoleId = sessionStorage.getItem('user_role_id')
  get isStep2Visible(): boolean {
    return this.currentUserRoleId != '6';
  }
  searchSchemes(event: AutoCompleteCompleteEvent) {
    let query = event.query.toLowerCase();
    this.filteredSchemes = this.schemes.filter(scheme =>
      scheme.name.toLowerCase().includes(query) ||
      scheme.description.toLowerCase().includes(query)
    );
    // ✅ If you're in existing mode, apply the phase filter too
    if (this.addMode === 'existing') {
      this.filteredSchemes = this.filteredSchemes.filter(scheme =>
        scheme.phase?.includes(this.selectedPhaseId)
      );
    }
  }


  searchProposals(event: Event) {
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    console.log(value)
    this.searchProposalQuery = value;
    // let originalProposalData = [...this.proposalData]

    // Always use the original data (copy) for filtering
    if (!value) {
      this.proposalData = [...this.orgProposal]; // Assuming you have the original data stored
    } else {
      this.proposalData = this.orgProposal.filter(proposal =>
        proposal.name?.toLowerCase().includes(value) ||
        proposal.description?.toLowerCase().includes(value) ||
        proposal.scheme?.name?.toLowerCase().includes(value)
      );
      console.log(this.proposalData)
    }

    this.currentPage = 1;
  }


  navigateToScheme(schemeName: any) {
    // this.router.navigate(['/transaction']);
    this.schemeService.setScheme(schemeName);
    this.router.navigate(['/proposal-dashboard'], { queryParams: { scheme: schemeName.name, id: schemeName.id, phase: this.activePhaseId } });
  }

  confirmSkipStage() {
    const updatedStages = this.stages.map(stage => {
      const isSkipped = stage.code === 'R-POC' ? true : stage.skipped || false;

      // Create a shallow copy and modify it
      const { week_timeline, percentage, ...rest } = stage;

      return {
        ...rest,
        skipped: isSkipped,
        week_timeline: week_timeline || null,
        percentage: percentage || null,
      };
    });

    const sub = this.apiService.postAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/`, updatedStages).subscribe((res: any) => {
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Stages Skipped Successfully' });
      this.apiCallForTransaction()
      const routeIndex = this.items.findIndex(i => i.label === 'Route Configuration');
      if (routeIndex !== -1) {
        this.activeIndex = routeIndex;
      }
    });
    this.subscriptions.add(sub);

  }

  skipStage(proposal: any) {
    this.isSkipStep = true;
  }

  onPageChange(event: any) {
    this.currentPage = event.page + 1;
  }

  addProposal(mode: 'new' | 'existing' = 'new', scheme?: any) {
    if (scheme) {
      this.selectedSchemeN = scheme
    }
    if (this.currentUserRoleId == '6') {
      this.items = [
        { label: 'Add Proposal', command: () => this.activeIndex = 0 },
        { label: 'Skip Stages', command: () => this.activeIndex = 1 },
        { label: 'Route Configuration', command: () => { this.apiCallForTransaction(); this.activeIndex = 2; } }
      ];
    } else {
      this.items = [
        { label: 'Add Proposal', command: () => this.activeIndex = 0 },
        { label: 'Route Configuration', command: () => { this.apiCallForTransaction(); this.activeIndex = 1; } }
      ];
    }

    this.transactionPhaseStages = []
    this.addMode = mode;
    this.activeTabName = this.tabList[this.activeTabIndex]?.name || '';
    this.proposalForm.reset()
    this.routeForm.reset()
    this.proposalForm.get('scheme')?.enable();
    this.proposalForm.get('scheme')?.patchValue(this.selectedSchemeN.id);

    this.activeIndex = 0;
    // this.isAddProposal = true;
    this.addProposalVisible = true;
    this.isUpdateProposal = false;
    this.currentPhaseName = '';
    this.getSchemes(mode);
    // this.getFunds();
  }
  onSubmit() {
    const data = {
      "name": this.proposalForm.get('proposalName')?.value,
      "description": this.proposalForm.get('description')?.value,
      "scheme": this.proposalForm.get('scheme')?.value,
      // "fund": this.proposalForm.get('fund')?.value?.id,
      "phase": this.activePhaseId,
      "status": 1
    }
    if (this.isUpdateProposal) {
      const sub = this.apiService.putAPI(`/master/proposals/${this.selectedProposal.id}/`, data).subscribe((res: any) => {
        this.selectedProposal = res;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal Added Successfully' });
        this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
        this.activeIndex = 1;
        this.getProposal()
      })
      this.subscriptions.add(sub);
    } else {
      const sub = this.apiService.postAPI('/master/proposals/', data).subscribe((res: any) => {
        this.selectedProposal = res;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal Added Successfully' });
        this.getStages(this.proposalForm.get('scheme')?.value, 'no');
        this.getProposal();
        // Dynamically insert steps based on conditions
        if (this.addMode === 'existing') {
          this.insertIntermediateSteps(this.proposalForm.get('scheme')?.value, this.activePhaseId);
          this.activeIndex = 1;
          this.currentPhaseName = this.activeTabName;
          this.fetchAndSubmitProposalSteps(
            this.proposalForm.get('scheme')?.value,
            this.proposalForm.get('scheme')?.value?.name,
            this.selectedProposal.id,
            this.activePhaseId
          );
        } else {
          this.activeIndex += 1; // go to next step directly
        }
      });
      this.subscriptions.add(sub);

    }
  }

  insertIntermediateSteps(scheme: any, phaseId: any) {
    const currentPhase = this.tabList?.find(p => p.id === phaseId);
    const phaseName = currentPhase?.name;

    this.currentPhaseName = phaseName;

    const firstStep = { label: 'Add Proposal' };
    const mandatoryStep = { label: 'Mandatory steps from Previous Phases' };
    const lastSteps = [
      { label: 'Skip Stages' },
      { label: 'Route Configuration' }
    ];

    const newSteps = [];

    if (phaseName === 'Prototype Development' || phaseName === 'Mass Production') {
      newSteps.push(mandatoryStep);
    }

    this.items = [firstStep, ...newSteps, ...lastSteps];
  }


  next() {
    this.activeIndex += 1;
    this.getProposal();
  }

  updateProposal(proposal: any) {
    this.selectedProposal = proposal;  // Store selected proposal
    this.isUpdateProposal = true;
    this.addProposalVisible = true;
    this.activeIndex = 0;
    this.proposalForm.patchValue({
      proposalName: proposal.name,
      scheme: proposal.scheme.id,
      // fund: proposal.fund,
      description: proposal.description
    });

    // Make sure the scheme dropdown correctly displays the name
    this.populateScheme(proposal.scheme);
    this.getSchemes();
    // this.getFunds();
    this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    // Important: Disable scheme control manually
    this.proposalForm.get('scheme')?.disable();

  }
  // 🛠 Populate Scheme Dropdown Based on Stored ID
  populateScheme(schemeId: number) {
    const selectedScheme = this.schemes.find(s => s.id === schemeId);
    if (selectedScheme) {
      this.proposalForm.patchValue({ scheme: selectedScheme.id });
    }
  }
  onUpdateSubmit() {
    let schemeId = this.selectedProposal.id
    let payload = {
      name: this.proposalForm.get('proposalName')?.value,
      description: this.proposalForm.get('description')?.value,
      scheme: this.proposalForm.get('scheme')?.value.id,
      // fund: this.proposalForm.get('fund')?.value.id,
      status: 1
    }
    const sub = this.apiService.putAPI(`/master/proposals/${schemeId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Proposal updated successfully'
        });
        this.isUpdateProposal = false;
        this.proposalForm.reset();
        this.selectedScheme = null;
        // this.proposalData.push(res);
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.detail
        });
      }
    });
    this.subscriptions.add(sub);
    this.isUpdateProposal = false; // Close the popup
  }
  deleteProposal(proposal?: any) {
    this.isDeleteProposal = true;
    this.selectedProposal = proposal

  }
  confirmDelete() {
    if (this.isDeleteProposal) {
      let schemeId = this.selectedProposal.id
      const sub = this.apiService.deleteAPI(`/master/proposals/${schemeId}/`).subscribe((res: any) => {
        // if (res) {
        this.isDeleteProposal = false
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Proposal Deleted Successfully'
        });
        // }
        this.getProposal();
      });
      this.subscriptions.add(sub);
    }
  }
  getSchemes(mode?: 'new' | 'existing') {
    const sub = this.apiService.getAPI('/master/scheme/').subscribe((res: any) => {
      this.schemes = res;
      this.filteredSchemes = [...this.schemes]
      if (mode === 'existing') {
        // Make sure selectedPhaseId is set before this!
        this.filteredSchemes = this.schemes.filter(scheme =>
          scheme.phase?.includes(this.selectedPhaseId)
        );
      }
    });
    this.subscriptions.add(sub);
  }
  getFunds() {
    const sub = this.apiService.getAPI('/master/fund/').subscribe((res: any) => {
      this.funds = res.data;
      this.filteredFunds = [...this.funds]

    });
    this.subscriptions.add(sub);

  }
  getUnit() {
    const sub = this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    })
    this.subscriptions.add(sub);
  }
  filterFunds(event: any) {
    const query = event.query.toLowerCase();
    this.funds = this.filteredFunds.filter(fund =>
      `${fund.major_head} ${fund.minor_head}`.toLowerCase().includes(query)
    );
  }

  onFundSelect(fund: any) {
    this.selectedFundDisplay = `${fund.major_head} - ${fund.minor_head}`;
    this.proposalForm.get('fund')?.setValue(fund.id);
  }
  getProposal() {
    const sub = this.apiService.getAPI(`/master/proposals/?scheme__phase=${this.activePhaseId}`).subscribe((res: any) => {
      this.proposalData = res.data;
      this.filteredRecentProposals = [...this.proposalData]
    });
    this.subscriptions.add(sub);
  }



  onActiveIndexChange(event: any) {
    this.activeIndex = event;
  }
  setActiveIndex(index: number): void {
    this.activeIndex = index;

    // Handle role-specific actions
    if (this.currentUserRoleId == '6') {
      if (index === 2) { // Route Configuration for role 6
        this.apiCallForTransaction();
      }
    } else {
      if (index === 1) { // Route Configuration for other roles
        this.apiCallForTransaction();
      }
    }
  }
  onAllRolesSame(isSame: boolean) {
    const userId = sessionStorage.getItem('user_id');

    if (userId) {
      const matchedUser = this.userList.find(user => user.id == userId);

      if (matchedUser) {
        if (isSame) {
          this.routeForm.patchValue({
            unit: matchedUser.unit.id,
            user: matchedUser.id
          });
        } else {
          // Optionally reset the fields
          this.routeForm.patchValue({
            unit: null,
            user: null
          });
        }
      } else {
        console.warn('User ID not found in users list.');
      }
    } else {
      console.warn('User ID not found in session storage.');
    }

  }
  onrouteFormSubmit() {
    // if (this.routeForm.invalid) return;

    const formValue = this.routeForm.value;

    let payload;
    if (!formValue.approved) {
      payload = {
        status: 1,
        sequence: this.routeForm.get('level')?.value, // Convert level input to number
        proposal_step: formValue.step,
        user: formValue.user,
        role: formValue.role,
        unit: formValue.unit,
        is_final_approve: formValue.approved || false
      };
    } else {
      let id = sessionStorage.getItem('user_id')
      let role = sessionStorage.getItem('user_role_id')
      payload = {
        proposal_step: formValue.step,
        user: formValue.user,
        unit: formValue.unit,
        role: this.roleList[2].id,
        is_final_approve: formValue.approved || true
      }
    }

    const sub = this.apiService.postAPI(`/transaction/proposal-workflow/?proposal_step_id=${formValue.step}`, payload).subscribe({
      next: (res: any) => {

        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: res.message || 'Route configuration added successfully.',
        // });
        this.routeForm.reset()
        this.getProposalWorkflow(formValue.step);
      },
      error: (err) => {
        // console.error('Update failed:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        // });
      }
    });
    this.subscriptions.add(sub);
  }


  getRoleList() {
    const sub = this.apiService.getAPI('/access/user-roles/').subscribe((res: any) => {
      const rolePriority = ['INT', 'REC', 'APP'];  // desired order
      const resp = res.data;

      // Filter and sort
      this.roleList = resp
        .filter(role => rolePriority.includes(role.code))
        .sort((a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code));
    });
  }
  getUserList() {
    const sub = this.apiService.getAPI('/account/users/').subscribe((res: any) => {
      const allUsers = res.data;
      const filteredUsers = allUsers.filter((user: any) =>
        !(user.roles && user.roles[0].code === 'ADMIN')
      );
      this.userList = filteredUsers;
      this.userListCopy = [...this.userList]
    })
  }


  onRoleChange(event: any) {
    this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value
    this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
  tryFetchingSequence() {
    if (this.stepId && this.roleID && this.userID) {
      this.getSequence();
    }
  }

  getSequence() {
    const sub = this.apiService.getAPI(`/transaction/get-next-level/?proposal_step_id=${this.stepId}&role_id=${this.roleID}`)
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }


  apiCallForTransaction() {
    // this.getStages(this.proposalForm.get('scheme')?.value?.id,'pass');
    this.getUnit()
    this.getRoleList();
    this.getUserList();
    const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`).subscribe((res: any) => {
      // this.stagesList = res
      // this.stagesList = res
      if (this.currentUserRoleId == '6') {
        // Role 6 gets full list
        this.stagesList = res;
      } else {
        // Other roles only get the first stage
        this.stagesList = res.length ? [res[0]] : [];
      }
      this.filteredStagesList = this.stagesList.filter(step => !step.skipped);
      this.routeForm.get('step')?.setValue(this.stagesList[0].id);
      if (this.addMode == 'new') {
        let unit = sessionStorage.getItem('unit_id')
        let user = sessionStorage.getItem('user_id')
        this.userID = Number(user);
        this.roleID = this.roleList[0]?.id;
        this.routeForm.get('unit')?.patchValue(Number(unit));
        this.routeForm.get('user')?.patchValue(Number(user));
        this.routeForm.get('role')?.patchValue(this.roleList[0]?.id);
      }
      // this.routeForm.get('role')?.patchValue(this.roleList[0]?.id);
      this.stepId = this.stagesList[0].id
      this.tryFetchingSequence();
      this.getProposalWorkflow(this.stagesList[0].id);
    });
    this.subscriptions.add(sub);

  }
  getStages(schemeId: any, pass: any) {
    if (this.isUpdateProposal && pass == 'pass') {
      const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?phase_id=${this.activePhaseId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.master_step,
          step_mapping: item.step_mapping,
          name: item.name,
          sequence: item.sequence,
          skipped: item.skipped,
          code: item.code,
          remark: item.remark,
          isSelected: item.isSelected,
          week_timeline: item.week_timeline,
          percentage: item.percentage
        }));
        this.calculateCompletionSum()
        if (res.length < 1) {
          this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${this.activePhaseId}`)
            .subscribe((res: any) => {
              this.stages = res.map((item: any) => ({
                // master_step: item.step.id,
                step_mapping: item.id,
                name: item.step.name,
                sequence: item.sequence,
                skipped: item.step.code == 'R-POC' ? true : false,
                code: item.step.code,
                week_timeline: item.week_timeline,
                percentage: item.percentage,
                remark: '',
                isSelected: false
              }));
              this.calculateCompletionSum()
              if (this.currentUserRoleId != '6') {
                this.confirmSkipStage();
              }
            });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${this.activePhaseId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.step.id,
          step_mapping: item.id,
          name: item.step.name,
          sequence: item.sequence,
          skipped: item.step.code == 'R-POC' ? true : false,
          code: item.step.code,
          remark: '',
          week_timeline: item.week_timeline,
          percentage: item.percentage,
          isSelected: false
        }));
        this.calculateCompletionSum()
        if (this.currentUserRoleId != '6') {
          this.confirmSkipStage();
        }
      });
      this.subscriptions.add(sub);
    }
  }
  calculateCompletionSum(): void {
    this.completionSum = this.stages
      .filter(stage => !stage.skipped)
      .reduce((sum, stage) => sum + Number(stage.percentage || 0), 0);
  }
  getProposalWorkflow(id: any) {
    this.RouteUserList = [];
    const sub = this.apiService.getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`).subscribe((res: any) => {
      // this.RouteUserList = res.data;
      const allData = res.data || [];

      // Filter only users with role.code 'INT', 'APP', or 'REC'
      this.RouteUserList = allData.filter((user: any) =>
        ['INT', 'APP', 'REC'].includes(user.role.code) || user.is_final_approve
      );
    });
    this.subscriptions.add(sub);
  }

  navigateToSchemeTransaction(schemeName: any, phaseId: any) {
    if (schemeName.scheme.name == 'IDEX DISC') {
      this.router.navigate(['/idex-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    } else if (schemeName.scheme.name == 'IDEX 4 Fauji') {
      this.router.navigate(['/idex-fauji-transaction'], {
        queryParams: {
          id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id
        }
      });
    } else if (schemeName.scheme.name == 'IDEX ADITI') {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    }
    else if (schemeName.scheme.name == 'IDEX OC') {
      this.router.navigate(['/idex-oc-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    } else if (schemeName.scheme.name == 'Make I') {
      this.router.navigate(['/make-i-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    } else if (schemeName.scheme.name == 'Make II') {
      this.router.navigate(['/make-ii-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    } else if (schemeName.scheme.name == 'Make III') {
      this.router.navigate(['/make-ii-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    } else if (schemeName.scheme.name == 'TDF') {
      this.router.navigate(['/tdf-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id }
      });
    }
    else {
      this.router.navigate(['/transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, mode: this.addMode, step: schemeName.step_summary.current_step_id }
      });
    }

  }

  deleteUser(user: any) {
    const sub = this.apiService.deleteAPI(`/transaction/proposal-workflow/${user.id}/`).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'User deleted successfully.'
      })
      this.getProposalWorkflow(user.proposal_step.id);
    })
    this.subscriptions.add(sub);
  }
  onStepChange(event: any) {
    this.stepId = event.value;
    const sub = this.apiService.getAPI(`/transaction/proposal-workflow/?proposal_step_id=${event.value}`).subscribe((res: any) => {

      this.RouteUserList = res.data;
      if (res.data[0]) {
        this.routeForm.get('approved').patchValue(res.data[0]?.is_final_approve || false)
      } else {
        this.routeForm.get('approved').patchValue(false)
      }
    });
    this.subscriptions.add(sub);
    this.tryFetchingSequence();
  }
  filteredProposals(schemeName: string): any[] {
    return this.proposalData.filter(p => p?.scheme?.name === schemeName);
  }
  getTabs() {
    const sub = this.apiService.getAPI(`/master/phase/`).subscribe((res) => {
      let resp = res.data || res.results
      this.tabList = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
      this.activePhaseId = resp[0].id;
      this.getProposal();
    });
    this.subscriptions.add(sub);
  }



  onTabChange(event: any): void {
    this.activeTabIndex = event.index;
    this.currentPage = 1; // ✅ Reset to page 1 on tab switch
    this.activePhaseId = this.tabList[event.index]?.id;
    this.selectedPhaseId = this.tabList[event.index]?.id;
    this.getProposal()
    this.getFilteredProposals(this.activeTabIndex)
  }

  getFilteredProposals(tabIndex: number): any[] {
    if (!this.selectedSchemeN) return [];

    const phaseId = this.tabList[tabIndex].id;
    return this.filteredRecentProposals.filter(p =>
      p.scheme.id == this.selectedSchemeN.id && p.scheme.phase.includes(Number(phaseId))
    );
  }

  // Method to get paged proposals for current tab
  getPagedProposals(tabIndex: number): any[] {
    const filtered = this.getFilteredProposals(tabIndex);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return filtered.slice(startIndex, startIndex + this.itemsPerPage);
  }
  getDialogHeader(): string {
    if (this.isUpdateProposal) {
      return 'Update Proposal'
      // : `Update Proposal on ${this.activeTabName}`;
    } else {
      return this.addMode === 'new'
        ? 'Add New Proposal'
        : `Add Proposal to ${this.activeTabName}`;
    }
  }



  fetchAndSubmitProposalSteps(
    schemeId: number,
    scheme_Name: string,
    proposalId: number,
    phaseId: number
  ): void {
    let optionalStepCodes: string[] = [];
    const scheme = this.schemes.find(s => s.id === schemeId);  // 👈 find by ID
    if (!scheme) {
      console.error('Scheme not found for ID:', schemeId);
      return;
    }

    const schemeName = scheme.name;

    if (schemeName.includes('IDEX DISC') || schemeName.includes('IDEX 4 Fauji') || schemeName.includes('IDEX ADITI') || schemeName.includes('IDEX OC')) {
      optionalStepCodes = ['idex_001', 'R-VI', 'idex_005'];
    } else if (schemeName.includes('TDF')) {
      optionalStepCodes = ['R-SP', 'makeI_01', 'tdf_012', 'idex_005', 'makeI_06', 'R-AIP', 'tdf_05', 'R-AoN', 'R-VI', 'makeI_10', 'makeI_15', 'tdf_006', 'tdf_014'];
    } else if (schemeName.includes('Revenue')) {
      optionalStepCodes = ['R-ND', 'R-AIP', 'R-NOQA', 'R-VI', 'R-RFP-SOC', 'R-AoN', 'R-PRFPM', 'R-FS', 'R-PBC', 'R-TEC', 'R-BM', 'R-FO', 'R-PSO', 'Rev_011', 'Rev_012', 'idex_007', 'Rev_017', 'Rev_013', 'Rev_014'];
    } else if (schemeName.includes('Make I')) {
      optionalStepCodes = ['R-ND', 'R-AIP', 'make_020', 'makeI_06', 'makeI_23', 'R-RFP-SOC', 'R-AoN', 'makeI_10', 'makeI_14', 'makeI_15', 'idex_17', 'R-FO', 'R-PSO', 'idex_007', 'idex_009', 'makeI_07', 'make1_001'];
    } else if (schemeName.includes('Make II') || schemeName.includes('Make III')) {
      optionalStepCodes = ['makeI_01', 'R-AIP', 'make_020', 'makeI_06', 'makeI_23', 'R-RFP-SOC', 'R-AoN', 'makeI_13', 'R-PSO', 'idex_007', 'idex_009', 'makeI_23', 'make1_001'];
    }

    const index = this.tabList.findIndex(p => p.name === this.currentPhaseName);

    if (index > 0) {
      for (let i = 0; i < index; i++) {
        const phase = this.tabList[i];

        const sub = this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${phase.id}`)
          .subscribe(
            (res: any) => {
              const stagePayload = res.map((item: any) => {
                const skipped = !optionalStepCodes.includes(item.step.code);

                return {
                  step_mapping: item.id,
                  name: item.step.name,
                  sequence: item.sequence,
                  skipped,
                  code: item.step.code,
                  remark: '',
                  isSelected: false,
                  ...(skipped === false && { make_initiator: true })  // ✅ Conditionally add the key
                };
              });


              this.transactionPhaseStages.push({
                phase: phase,
                stages: stagePayload
              });

              this.apiService.postAPI(`/transaction/proposals/${proposalId}/steps/`, stagePayload)
                .subscribe(
                  (submitRes: any) => {
                  },
                  (submitErr) => {
                  }
                );
            },
            (err) => {
            }
          );
        this.subscriptions.add(sub);
      }
    }
  }


  setActivePhase(phaseName: string) {
    this.currentPhaseName = phaseName;
    // this.populatePreviousPhaseStages();
  }
  completionSum: any;
  anyCompletionEntered = false;
  allCompletionFilled = false;

  onCompletionChange() {
    const completions = this.stages.map(s => s.percentage);
    const enteredValues = completions.filter(c => c !== null && c !== undefined && c !== '');
    const sum = enteredValues.reduce((acc, val) => acc + Number(val), 0);

    this.completionSum = sum;

    // Check if any completion is filled
    this.anyCompletionEntered = enteredValues.length > 0;

    // Check if all are filled when any is entered
    this.allCompletionFilled = completions.every(c => c !== null && c !== undefined && c !== '');

    // You can use these flags to enable/disable submit button or show validation errors
  }
  canSubmit(): boolean {
    const relevantSteps = this.steps.filter(step => !step.skipped);

    const completions = relevantSteps.map(step => step.completion);
    const anyEntered = completions.some(value => value != null && value !== '');
    const allFilled = completions.every(value => value != null && value !== '');
    const totalSum = completions.reduce((sum, val) => sum + (+val || 0), 0);

    // If none entered — allow submit
    if (!anyEntered) return true;

    // If some filled, only allow if all are filled and total ≤ 100
    return allFilled && totalSum <= 100;
  }
  selectedSchemeN: any = null; // To track the selected scheme
  allProposals: any[] = []; // Your list of schemes

  // Method to handle scheme selection
  selectScheme(scheme: any) {
    this.selectedSchemeN = scheme;
    this.activeTabIndex = 0; // Reset to first tab
    this.currentPage = 1; // Reset pagination
    // Filter proposals based on selected scheme
    this.filterProposalsByScheme(scheme.id);
  }

  // Method to go back to schemes view
  backToSchemes() {
    this.selectedSchemeN = null;
    // Reset to show all proposals or whatever your default is
    this.resetProposals();
  }
  orgProposal: any
  // Method to filter proposals by scheme
  filterProposalsByScheme(schemeId: string) {
    this.proposalData = this.filteredRecentProposals.filter(p => p.scheme.id == schemeId);
    this.orgProposal = [...this.proposalData]

    // Reset pagination
    this.currentPage = 1;
  }

  // Method to reset proposals
  resetProposals() {
    this.proposalData = [...this.filteredRecentProposals];
    this.currentPage = 1;
  }
}
